<div class="toggle-button" [ngClass]="{'active' : option }">
    <div class="toggle"></div>
</div>